var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSprechblase = function SvgSprechblase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15.82 6.25v6.68M12 8.16v4.77M8.18 10.07v2.86M1.5 5.3v9.54a3.82 3.82 0 0 0 3.82 3.82h1.91v2.86L13 18.66h5.73a3.82 3.82 0 0 0 3.82-3.82V5.3a3.82 3.82 0 0 0-3.82-3.82H5.32A3.82 3.82 0 0 0 1.5 5.3Z"
  })));
};
export default SvgSprechblase;